import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultipleSelectItemComponent } from './multiple-select-item/multiple-select-item.component';
import { InventoryRoutingModule } from './inventory-routing.module';
import { StoresComponent } from './stores/stores.component';
import { TransactionComponent } from './transaction/transaction.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { PipeModuleModule } from '../pipe/pipe-module/pipe-module.module';
import { StageSelectionComponent } from './stage-selection/stage-selection.component';
import { StockComponent } from './stock/stock.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule, MatRippleModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ItemEntryComponent } from './item-entry/item-entry.component';
import { StoreTransferComponent } from './store-transfer/store-transfer.component';
import { ProductUnitsComponent } from './product-units/product-units.component';
import { UnitsComponent } from './units/units.component';
import { CategoriesComponent } from './categories/categories.component';
import { ValuationComponent } from './valuation/valuation.component';
import { SubCategoriesComponent } from './sub-categories/sub-categories.component';
import { ProductBOMComponent } from './product-bom/product-bom.component';
import { TransactionJobsComponent } from './transaction-jobs/transaction-jobs.component';
import { ProductByproductsComponent } from './product-byproducts/product-byproducts.component';
import { SelectCustomerComponent } from './select-customer/select-customer.component';
import { SelectExecutiveComponent } from './select-executive/select-executive.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { SettingsComponent } from './settings/settings.component';
//import { MatAutocompleteModule } from '@angular/material/autocomplete/autocomplete-module'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SelectStoreComponent } from './select-store/select-store.component';
import { ReportComponent } from './report/report.component';
import { SelectJobComponent } from './select-job/select-job.component';
import { CopyFromProductComponent } from './copy-from-product/copy-from-product.component';
import { StockExpandComponent } from './stock-expand/stock-expand.component';
import { HSNListComponent } from './hsn-list/hsn-list.component';
import { TagsComponent } from './tags/tags.component';
import { ImportItemsComponent } from './import-items/import-items.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HSNSACComponent } from './hsn-sac/hsn-sac.component';
import { MultiUnitCalculatorComponent } from './multi-unit-calculator/multi-unit-calculator.component';
import { ImportledgerComponent } from './importledger/importledger.component';
import { TransactionProductionComponent } from './transaction-production/transaction-production.component';
import { BatchSelectionComponent } from './batch-selection/batch-selection.component';
import { LZStringModule } from 'ng-lz-string';
import { ItemSummaryComponent } from './item-summary/item-summary.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { GspcReconcileComponent } from './gspc-reconcile/gspc-reconcile.component';
import { ImportBOMComponent } from './import-bom/import-bom.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ValidateImportItemsComponent } from './validate-import-items/validate-import-items.component';


@NgModule({
  declarations: [
    MultipleSelectItemComponent,
    ProductDetailComponent,
    TransactionComponent,
    StoreTransferComponent,
    StageSelectionComponent,
    StoresComponent,
    ItemEntryComponent,
    StockComponent,
    ProductUnitsComponent,
    UnitsComponent,
    CategoriesComponent,
    ValuationComponent,
    SubCategoriesComponent,
    ProductUnitsComponent,
    StoresComponent,
    SelectStoreComponent,
    ProductBOMComponent,
    TransactionJobsComponent,
    ProductByproductsComponent,
    SelectCustomerComponent,
    SelectExecutiveComponent,
    SettingsComponent,
    ValuationComponent,
    ReportComponent,
    SelectJobComponent,
    CopyFromProductComponent,
    StockExpandComponent,
    CopyFromProductComponent,
    HSNListComponent,
    TagsComponent,
    ImportItemsComponent,
    HSNSACComponent,
    MultiUnitCalculatorComponent,
    ImportledgerComponent,
    TransactionProductionComponent,
    BatchSelectionComponent,
    ItemSummaryComponent,
    GspcReconcileComponent,
    ImportBOMComponent,
    ValidateImportItemsComponent

  ],
  imports: [
    CommonModule,
    InventoryRoutingModule,
    PipeModuleModule,
    FormsModule,
    InventoryRoutingModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatSortModule,
    NgxSpinnerModule,
    LZStringModule,
    MatExpansionModule,
    DragDropModule

  ],
  exports: [
    MatPaginatorModule,
    MatSortModule,
    MultipleSelectItemComponent
  ],
  entryComponents: [HSNListComponent,SelectStoreComponent, ItemEntryComponent, SelectCustomerComponent, SelectExecutiveComponent, SelectJobComponent, MultipleSelectItemComponent, CopyFromProductComponent]
})
export class InventoryModule { }
